import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Button } from "react-bootstrap";
import MoonLight from "../assets/images/moon.svg";
import SunLight from "../assets/images/sunny.svg";
import { useDispatch, useSelector } from "react-redux";
import MobLeftbar from "./MobLeftbar";
import GamesSearchModal from "../views/components/GamesSearchModal";
import { AuthModals } from "../config/const";
import HomeIcon from "../assets/images/icons/header/home.png";
import HomeIcon3D from "../assets/images/icons/header/home-3dNew.png";
import ExchangeIcon from "../assets/images/icons/header/bats.png";
import ExchangeIcon3D from "../assets/images/icons/header/cricketNew.png";
import LiveDealerIcon from "../assets/images/icons/header/spades.png";
import LiveDealerIcon3D from "../assets/images/icons/header/ace-of-spadesNew.png";
import GameShowIcon from "../assets/images/icons/header/remote.png";
import GameShowIcon3D from "../assets/images/icons/header/gamepadNew.png";
import AviatorIcon3D from "../assets/images/icons/header/lottery3dNew.png";
import AviatorIcon from "../assets/images/icons/header/lottery.png";
import MinesIcon from "../assets/images/icons/header/texas-holdem-poker.png";
import MinesIcon3D from "../assets/images/icons/header/tablegame.png";
import AeSexyIcon from "../assets/images/icons/header/slots.png";
import AeSexyIcon3D from "../assets/images/icons/header/jackpotNew.png";
import {
  getNotifications,
  setActiveAuthModalAction,
} from "../redux/app/actions";
import { AiOutlineClose } from "react-icons/ai";
import SecondaryLeftBar from "./SecondaryLeftBar";
import MenuIcon from "../assets/images/icons/menu.png";
import { RouteType, useAppNavigate } from "../hooks/useAppNavigate";
import { useLeftBarHook } from "../hooks/useLeftBarHook";

const Header = () => {
  const { appDetails } = useSelector((state) => state.app);
  const [isClassAdded, setIsClassAdded] = useState(false);
  const [show1, setShow1] = useState(false);
  const [websiteNotifications, setWebsiteNotifications] = useState([]);
  const [showNotifications, setShowNotifications] = useState(true);
  const dispatch = useDispatch();
  const { isSecondaryLeftBarOpen } = useSelector((state) => state.app);
  const leftBarHook = useLeftBarHook();
  const { appNavigate } = useAppNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    const isClassAddedLocalStorage = localStorage.getItem("isClassAdded");
    if (isClassAddedLocalStorage) {
      setIsClassAdded(true);
      document.body.classList.add("light-theme");
    }
    loadNotifications();
  }, []);

  const toggleClass = () => {
    if (isClassAdded) {
      setIsClassAdded(false);
      localStorage.removeItem("isClassAdded");
      document.body.classList.remove("light-theme");
    } else {
      setIsClassAdded(true);
      localStorage.setItem("isClassAdded", true);
      document.body.classList.add("light-theme");
    }
  };

  const loadNotifications = async () => {
    // get notifications
    const notifications = await getNotifications();
    if (notifications && notifications?.data?.data) {
      setShowNotifications(true);
      setWebsiteNotifications(notifications?.data?.data);
    }
  };

  const isActivePath = (url) => {
    return url === pathname;
  };

  return (
    <>
      {(websiteNotifications.length && showNotifications && (
        <div className="marqu">
          <marquee>
            {websiteNotifications.map((notf, idx) => (
              <label key={idx}>{notf?.content}</label>
            ))}
          </marquee>
          <span onClick={() => setShowNotifications(false)}>
            <AiOutlineClose />
          </span>
        </div>
      )) ||
        null}

      <header className="header header_bfrlgn">
        {isSecondaryLeftBarOpen && <SecondaryLeftBar />}
        <div className="topHead">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="d-flex align-items-center justify-content-between flex-wrap headerBefore">
                  <Button
                    onClick={() => {
                      leftBarHook.toggleLeftBar();
                    }}
                    className="MenuBtn">
                    <img src={MenuIcon} alt="MenuIcon" />
                  </Button>
                  <div className="logo">
                    <a href="/">
                      <img src={appDetails?.LOGO_URL} alt="Logo" />
                    </a>
                  </div>

                  <div className="headerRight ms-auto ms-xl-0">
                    <ul className="" style={{ marginLeft: "5px" }}>
                      <li></li>
                    </ul>

                    <div className="theme-btn me-2">
                      <button
                        type="button"
                        className="btn"
                        onClick={toggleClass}>
                        <img src={SunLight} alt="sun" className="light_theme" />
                        <img
                          src={MoonLight}
                          alt="moon"
                          className="dark_theme"
                        />
                      </button>
                    </div>

                    <Button
                      variant="primary"
                      onClick={() => {
                        // navigate("/sign-in");
                        dispatch(setActiveAuthModalAction(AuthModals.Login));
                      }}
                      className="login_btn me-2">
                      Login
                    </Button>
                    <Button
                      variant="primary"
                      onClick={() => {
                        dispatch(setActiveAuthModalAction(AuthModals.Register));
                      }}
                      className="signup_btn">
                      Registration
                    </Button>
                    {/* <div className="searchbar">
                    <AiOutlineSearch />
                  </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="subHead">
          <ul>
            <li>
              <GamesSearchModal />
            </li>
            <li>
              <a
                href="/sports"
                className={
                  isActivePath("/sports") || isActivePath("/") ? "active" : ""
                }>
                <img src={HomeIcon} alt="home" className="nactv" />
                <img src={HomeIcon3D} alt="home" className="actv" />
                <span>Lobby</span>
              </a>
            </li>
            <li>
              <a
                onClick={() => {
                  appNavigate("/sportsbook/Inplay", RouteType.Protected);
                }}
                href="javascript:void(0)"
                className={isActivePath("/sportsbook/Inplay") ? "active" : ""}>
                <img src={ExchangeIcon} alt="exchange" className="nactv" />
                <img src={ExchangeIcon3D} alt="exchange" className="actv" />
                <span>Sports</span>
              </a>
            </li>

            <li>
              <a
                href="/casino-types/casino"
                className={
                  isActivePath("/casino-types/casino") ? "active" : ""
                }>
                <img
                  src={LiveDealerIcon}
                  alt="live dealers"
                  className="nactv"
                />
                <img
                  src={LiveDealerIcon3D}
                  alt="live dealers"
                  className="actv"
                />
                <span>Casino</span>
              </a>
            </li>
            <li>
              <a
                href="/casino-types/miniGames"
                className={
                  isActivePath("/casino-types/miniGames") ? "active" : ""
                }>
                <img src={GameShowIcon} alt="game shows" className="nactv" />
                <img src={GameShowIcon3D} alt="game shows" className="actv" />
                <span>Mini Games</span>
              </a>
            </li>
            <li>
              <a
                href="/casino-types/lotterygames"
                className={
                  isActivePath("/casino-types/lotterygames") ? "active" : ""
                }>
                <img src={AviatorIcon} alt="aviator" className="nactv" />
                <img src={AviatorIcon3D} alt="aviator" className="actv" />
                <span>Lottery</span>
              </a>
            </li>
            <li>
              <a
                href="/casino-types/tablegames"
                className={
                  isActivePath("/casino-types/tablegames") ? "active" : ""
                }>
                <img src={MinesIcon} alt="mines" className="nactv" />
                <img src={MinesIcon3D} alt="mines" className="actv" />
                <span>Table Games</span>
              </a>
            </li>
            <li>
              <a
                href="/casino-types/slotsgames"
                className={
                  isActivePath("/casino-types/slotsgames") ? "active" : ""
                }>
                <img src={AeSexyIcon} alt="aesexy" className="nactv" />
                <img src={AeSexyIcon3D} alt="aesexy" className="actv" />
                <span>Slots</span>
              </a>
            </li>
          </ul>
        </div>

        {/* <Offcanvas
        className={"steps-canvas"}
        show={show}
        onHide={handleClose}
        placement={"end"}
      >
        <Offcanvas.Header closeButton="closeButton" closeVariant="white">
          <Offcanvas.Title>
            <span className="top-heading">Sign in now!</span>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="form-steps">
            <h2 className="h2">Hello Again!</h2>
            <p>
              Welcome back, you've
              <br />
              been missed!
            </p>
            <Form>
              <Form.Group className="mb-3" controlId="formBasicName">
                <Form.Control type="text" placeholder="Enter Username*" />
              </Form.Group>
              <Form.Group
                className="mb-3 position-relative"
                controlId="formBasicPassword"
              >
                <Form.Control type="password" placeholder="Password*" />
                <span className="icon">
                  <EyeIcon />
                </span>
              </Form.Group>
              <div className="d-flex justify-content-end mb-3">
                <a className="form-link" href="#">
                  Password Recovery
                </a>
              </div>
              <Button variant="primary" type="submit">
                Log in
              </Button>
            </Form>
            <div className="sign-up mt-4">
              Not a member?
              <br />
              <a href="register">Sign Up Now</a>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas> */}
        {show1 && <MobLeftbar className="d-block d-md-none" />}
      </header>
    </>
  );
};

export default Header;
